import createGetFormInitialValues from '../selectors/getFormInitialValues';
import immutable from '../structure/immutable';

export default createGetFormInitialValues(immutable);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/immutable/getFormInitialValues.js
// module id = 1196
// module chunks = 0